<template>
  <div>
    <!-- Page Header -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="page-title mb-0">Domain Detection Summary</h1>
      <!-- <div class="d-flex align-items-center" style="gap: 8px;">
        <div v-if="latestUpdate" class="d-flex align-items-center" style="gap: 6px;">
          <span style="font-size: 14px; font-weight: 500; color: #4b4b4b; white-space: nowrap;">
            Latest Update: {{ latestUpdate }}
          </span>
          <span id="latest-update-info" style="cursor: pointer;" v-b-tooltip.hover title="Data diperbarui harian (D-1)">
            <i class="fal fa-info-circle" style="color: #9d9d9d; font-size: 12px;"></i>
          </span>
        </div>
      </div> -->
    </div>

    <!-- Filter Bar -->
    <div class="filter-bar mb-4">
      <div class="filter-bar__item">
        <domain-checkbox-dropdown ref="refDomain" v-model="filter.domain" :options="filterOptions.domains"
          :max-select="3" placeholder="All Domains" @open="closeOtherDropdowns('refDomain')" />
      </div>
      <div class="filter-bar__item">
        <single-select-dropdown ref="refProvince" v-model="filter.province" :options="filterOptions.provinces"
          placeholder="All Provinsi" title="Select Provinsi" @open="closeOtherDropdowns('refProvince')" />
      </div>
      <div class="filter-bar__item">
        <single-select-dropdown ref="refRegion" v-model="filter.region" :options="filterOptions.regions"
          placeholder="All Region" title="Select Region"
          :empty-message="filter.province ? 'No results' : 'Pilih provinsi terlebih dahulu'"
          @open="closeOtherDropdowns('refRegion')" />
      </div>
      <div class="filter-bar__item">
        <single-select-dropdown ref="refDistrict" v-model="filter.district" :options="filterOptions.districts"
          placeholder="All District" title="Select District"
          :empty-message="filter.region ? 'No results' : 'Pilih Kabupaten/Kota terlebih dahulu'"
          @open="closeOtherDropdowns('refDistrict')" />
      </div>
      <button class="btn-reset-filter" :class="{ 'btn-reset-filter--active': isFilterActive }" @click="resetFilter">
        <!-- <i class="fas fa-undo" style="font-size: 12px;"></i> -->
        <font-awesome-icon icon="undo" style="font-size: 12px;" />
        <span>Reset Filter</span>
      </button>
    </div>

    <!-- Stats Cards -->
    <div class="d-flex mb-4" style="gap: 16px;">
      <domain-summary-stats-card title="Total Scans" :value="summary.totalScans" icon-bg-color="#dcefff">
        <template #icon>
          <!-- <font-awesome-icon :icon="['fas', 'qrcode']" style="font-size: 18px; color: #2196f3;" /> -->
          <img :src="require('@/assets/icons/domain-detection/total-scan.svg')" width="33" height="33" />
        </template>
      </domain-summary-stats-card>

      <domain-summary-stats-card title="Suspicious Domains" :value="summary.suspiciousDomains" icon-bg-color="#ffe6e6">
        <template #icon>
          <!-- <font-awesome-icon :icon="['fas', 'search']" style="font-size: 18px; color: #eb5464;" /> -->
          <img :src="require('@/assets/icons/domain-detection/suspicious-domain.svg')" width="33" height="33" />
        </template>
      </domain-summary-stats-card>

      <domain-summary-stats-card title="Total District" :value="summary.location" icon-bg-color="#fff3e2">
        <template #icon>
          <!-- <font-awesome-icon :icon="['fas', 'map-marker-alt']" style="font-size: 18px; color: #f3b343;" /> -->
          <img :src="require('@/assets/icons/domain-detection/total-district.svg')" width="33" height="33" />
        </template>
      </domain-summary-stats-card>

      <domain-summary-stats-card title="Total Dealer Apps" :value="summary.dealer" icon-bg-color="#f9efff">
        <template #icon>
          <!-- <font-awesome-icon :icon="['fas', 'store']" style="font-size: 18px; color: #ab6ef4;" /> -->
          <img :src="require('@/assets/icons/domain-detection/total-dealer-apps.svg')" width="33" height="33" />
        </template>
      </domain-summary-stats-card>
    </div>

    <!-- Map + Insights -->
    <div class="d-flex mb-4" style="gap: 16px;">
      <div
        style="flex: 0 0 67%; min-width: 0; border-radius: 8px; overflow: hidden; box-shadow: 0 0 3px rgba(0,0,0,0.16);">
        <domain-summary-heatmap :clusters="mapClusters"></domain-summary-heatmap>
      </div>
      <div style="flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 16px;">
        <domain-summary-suspicious-donut :domains="suspiciousDomainsPie"></domain-summary-suspicious-donut>
        <domain-summary-top5-dealer @detail="onDistrictDetail"></domain-summary-top5-dealer>
      </div>
    </div>

    <!-- Top 5 Suspicious Domains Table -->
    <domain-summary-top5-table :domains="top5Domains" :loading="isLoading" @watchlist="onWatchlist" @detail="onDetail"
      @viewAll="onViewAll"></domain-summary-top5-table>

    <!-- Watchlist Confirmation Modal -->
    <b-modal v-model="watchlistModal.show" centered size="sm" hide-header hide-footer>
      <div class="watchlist-modal">
        <div class="watchlist-modal__icon">
          <img :src="require('@/assets/icons/domain-detection/watchlist-warning.svg')" width="109" height="109" />
        </div>
        <div class="watchlist-modal__body">
          <p class="watchlist-modal__title">Watchlist This Domain?</p>
          <p class="watchlist-modal__subtitle">This domain's status will be changed to Watchlisted for ongoing
            monitoring.
          </p>
        </div>
        <div class="watchlist-modal__footer">
          <button class="watchlist-modal__btn watchlist-modal__btn--cancel" @click="watchlistModalHide">Cancel</button>
          <button class="watchlist-modal__btn watchlist-modal__btn--confirm" :disabled="watchlistModal.loading"
            @click="watchlistConfirm">
            <span v-if="watchlistModal.loading"><b-spinner small></b-spinner></span>
            <span v-else>Add to Watchlist</span>
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Watchlist Success Modal -->
    <b-modal v-model="successModal.show" centered size="sm" hide-header hide-footer>
      <div class="watchlist-modal">
        <div class="watchlist-modal__icon">
          <img :src="require('@/assets/icons/domain-detection/watchlist-success.svg')" width="134" height="134" />
        </div>
        <div class="watchlist-modal__body">
          <p class="watchlist-modal__title">Successfully Watchlisted Domain</p>
          <p class="watchlist-modal__subtitle">Domain successfully added to watchlist</p>
        </div>
        <div class="watchlist-modal__footer">
          <button class="watchlist-modal__btn watchlist-modal__btn--confirm"
            @click="successModal.show = false">OK</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import qs from 'qs'
import DomainCheckboxDropdown from './children/DomainCheckboxDropdown.vue'
import SingleSelectDropdown from './children/SingleSelectDropdown.vue'
import DomainSummaryStatsCard from './children/DomainSummaryStatsCard.vue'
import DomainSummaryHeatmap from './children/DomainSummaryHeatmap.vue'
import DomainSummarySuspiciousDonut from './children/DomainSummarySuspiciousDonut.vue'
import DomainSummaryTop5Dealer from './children/DomainSummaryTop5Dealer.vue'
import DomainSummaryTop5Table from './children/DomainSummaryTop5Table.vue'

export default {
  name: 'DomainDetectionSummary',
  metaInfo: { title: 'Domain Detection Summary' },
  components: {
    DomainCheckboxDropdown,
    SingleSelectDropdown,
    DomainSummaryStatsCard,
    DomainSummaryHeatmap,
    DomainSummarySuspiciousDonut,
    DomainSummaryTop5Dealer,
    DomainSummaryTop5Table,
  },
  data() {
    return {
      latestUpdate: null,
      filter: {
        domain: [],
        province: null,
        region: null,
        district: null,
      },
      filterOptions: {
        domains: [],
        provinces: [],
        regions: [],
        districts: [],
      },
      summary: {
        totalScans: 0,
        suspiciousDomains: 0,
        location: 0,
        dealer: 0,
      },
      mapClusters: [],
      suspiciousDomainsPie: [],
      top5Domains: [],
      isLoading: false,
      watchlistModal: {
        show: false,
        item: null,
        loading: false,
      },
      successModal: {
        show: false,
      },
    }
  },
  computed: {
    domainParam() {
      return this.filter.domain.length ? this.filter.domain.map(d => d.value).join(',') : null
    },
    isFilterActive() {
      return this.filter.domain.length > 0 || this.filter.province !== null || this.filter.region !== null || this.filter.district !== null
    },
  },
  watch: {
    'filter.domain'() {
      this.fetchData()
    },
    'filter.province'(val) {
      this.filter.region = null
      this.filter.district = null
      this.filterOptions.regions = []
      this.filterOptions.districts = []
      if (val) this.fetchRegions(val.value)
      this.fetchData()
    },
    'filter.region'(val) {
      this.filter.district = null
      this.filterOptions.districts = []
      if (val) this.fetchDistricts(val.value)
      this.fetchData()
    },
    'filter.district'() {
      this.fetchData()
    },
  },
  mounted() {
    this.fetchProvinces()
    this.fetchDomains()
    this.fetchOverview()
    this.fetchSuspiciousDonutChart()
    this.fetchMapData()
    this.fetchTop5Domains()
  },
  methods: {
    closeOtherDropdowns(exceptRef) {
      const allRefs = ['refDomain', 'refProvince', 'refRegion', 'refDistrict']
      allRefs.forEach(name => {
        if (name !== exceptRef && this.$refs[name]) this.$refs[name].close()
      })
    },
    async fetchProvinces() {
      try {
        const resp = await this.$http.get('/api/master/provinsi')
        this.filterOptions.provinces = (resp.data.data || []).map(p => ({
          name: p.nama_provinsi,
          value: p.kode_provinsi,
        }))
      } catch (err) {
        this.errorPrint(err)
      }
    },
    async fetchRegions(kodeProvinsi) {
      try {
        const resp = await this.$http.get(`/api/master/kotakabupaten?kode_provinsi=${kodeProvinsi}`)
        this.filterOptions.regions = (resp.data.data || []).map(r => ({
          name: r.nama_kotakab,
          value: r.kode_kotakab,
        }))
      } catch (err) {
        this.errorPrint(err)
      }
    },
    async fetchDistricts(kodeKotakabupaten) {
      try {
        const resp = await this.$http.get(`/api/master/kecamatan?kode_kotakabupaten=${kodeKotakabupaten}`)
        this.filterOptions.districts = (resp.data.data || []).map(d => ({
          name: d.nama_kecamatan,
          value: d.kode_kecamatan,
        }))
      } catch (err) {
        this.errorPrint(err)
      }
    },
    async fetchDomains() {
      try {
        const params = qs.stringify({ page: 1, limit: 9999, domain_status: '', search_domain: '' }, { skipNulls: false })
        const resp = await this.$http.get(`/api/domain-detection-review-domain/table?${params}`)
        const rows = (resp.data.data || {}).data || []
        this.filterOptions.domains = rows.map(d => ({
          name: d.domain_url,
          value: d.domain_id,
        }))
      } catch (err) {
        this.errorPrint(err)
      }
    },
    fetchData() {
      this.fetchOverview()
      this.fetchSuspiciousDonutChart()
      this.fetchMapData()
      this.fetchTop5Domains()
    },
    async fetchOverview() {
      try {
        const params = qs.stringify({
          domain: this.domainParam,
          province: this.filter.province ? this.filter.province.value : null,
          region: this.filter.region ? this.filter.region.value : null,
          district: this.filter.district ? this.filter.district.value : null,
        }, { skipNulls: true })
        const resp = await this.$http.get(`/api/domain-detection-summary/overview?${params}`)
        const d = resp.data.data || {}
        this.latestUpdate = d.latest_update || null
        this.summary = {
          totalScans: d.total_scan || 0,
          suspiciousDomains: d.total_suspicious_domain || 0,
          location: d.total_district || 0,
          dealer: d.total_dealer_apps || 0,
        }
      } catch (err) {
        this.errorPrint(err)
      }
    },
    async fetchSuspiciousDonutChart() {
      try {
        const resp = await this.$http.get('/api/domain-detection-summary/top-5-suspicious-domain-chart')
        this.suspiciousDomainsPie = (resp.data.data || []).map(d => ({
          name: d.domain,
          count: d.total,
          percent: d.percent,
        }))
      } catch (err) {
        this.errorPrint(err)
      }
    },
    async fetchMapData() {
      try {
        const params = qs.stringify({
          domain: this.domainParam,
          province: this.filter.province ? this.filter.province.value : null,
          region: this.filter.region ? this.filter.region.value : null,
          district: this.filter.district ? this.filter.district.value : null,
        }, { skipNulls: true })
        const resp = await this.$http.get(`/api/domain-detection-summary/map?${params}`)
        this.mapClusters = (resp.data.data || [])
          .filter(m => m.lat && m.lng)
          .map(m => ({ lat: m.lat, lng: m.lng }))
      } catch (err) {
        this.errorPrint(err)
      }
    },
    async fetchTop5Domains() {
      try {
        this.isLoading = true

        // const now = new Date()
        // const y = now.getFullYear()
        // const mo = String(now.getMonth() + 1).padStart(2, '0')
        // const lastDay = new Date(y, now.getMonth() + 1, 0).getDate()
        // const params = qs.stringify({
        //   page: 1,
        //   limit: 5,
        //   start_date: `${y}-${mo}-01`,
        //   end_date: `${y}-${mo}-${lastDay}`,
        //   domain: this.domainParam,
        //   province: this.filter.province ? this.filter.province.value : null,
        //   region: this.filter.region ? this.filter.region.value : null,
        //   district: this.filter.district ? this.filter.district.value : null,
        // }, { skipNulls: true })

        const resp = await this.$http.get(`/api/domain-detection-summary/top-5-suspicious-domain-list`)
        const rows = (resp.data || {}).data || []
        console.log("resp top 5 sus:", rows);

        this.top5Domains = rows.map(d => ({
          domainId: d.domain_id,
          domain: d.domain_url,
          totalScan: d.total_scan,
          firstScan: d.first_scan,
          location: d.total_region,
          district: d.total_district,
          riskScore: d.risk_score,
          domainStatus: d.domain_status === 'under_review' ? 'under-review' : (d.domain_status || ''),
        }))
      } catch (err) {
        this.errorPrint(err)
        // this.top5Domains = []
      } finally {
        this.isLoading = false
      }
    },
    resetFilter() {
      this.filter = { domain: [], province: null, region: null, district: null }
      this.filterOptions.regions = []
      this.filterOptions.districts = []
    },
    onWatchlist(item) {
      this.watchlistModal.item = item
      this.watchlistModal.show = true
    },
    watchlistModalHide() {
      this.watchlistModal.show = false
      this.watchlistModal.item = null
    },
    async watchlistConfirm() {
      this.watchlistModal.loading = true
      try {
        await this.$http.post('/api/domain-detection-review-domain/update-watchlist', {
          domain_id: this.watchlistModal.item.domainId,
          watchlist: true,
        })
        this.watchlistModal.show = false
        this.watchlistModal.item = null
        this.successModal.show = true
        this.fetchTop5Domains()
      } catch (err) {
        this.errorPrint(err)
      } finally {
        this.watchlistModal.loading = false
      }
    },
    onDetail(item) {
      this.$router.push({ name: 'ReviewDomainDetail', params: { domain_id: item.domainId } })
    },
    onDistrictDetail(item) {
      if (item.district) {
        this.filter.district = {
          label: item.district,
          value: item.district
        }
      }

      this.$router.push({
        // name: 'DomainDistribution',
        // params: { domain_id: item.domain_id }
        path: '/dashboard/domain-detection/domain-distribution',
        query: { 
          district: item.district,
          regency: item.regency,
          province: item.province,
         },
      })
    },
    onViewAll() {
      this.$router.push({ name: 'ReviewDomain' })
    },
  },
}
</script>

<style scoped>
.page-title {
  font-size: 16px;
  font-weight: 700;
  color: #4b4b4b;
}

/* Filter bar */
.filter-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  border-radius: 8px;
  box-shadow: 0 3px 2.5px rgba(0, 0, 0, 0.06);
}

.filter-bar__item {
  flex: 1;
  min-width: 0;
}

/* Reset filter button */
.btn-reset-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  height: 28px;
  background: #eaeaea;
  border: none;
  border-radius: 4px;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  font-weight: 500;
  color: #9d9d9d;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.btn-reset-filter:hover {
  background: #ddd;
}

.btn-reset-filter--active {
  background: white;
  color: #4b4b4b;
}

.btn-reset-filter--active:hover {
  background: #f5f5f5;
}

/* Watchlist / Success modals */
.watchlist-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 16px;
}

.watchlist-modal__icon {
  margin-bottom: 4px;
}

.watchlist-modal__body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: center;
  padding: 0 8px;
}

.watchlist-modal__title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  margin: 0;
}

.watchlist-modal__subtitle {
  font-size: 14px;
  color: rgba(165, 165, 165, 0.87);
  margin: 0;
}

.watchlist-modal__footer {
  display: flex;
  gap: 16px;
  width: 100%;
  padding: 10px 0 0;
}

.watchlist-modal__btn {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}

.watchlist-modal__btn--cancel {
  background: #fff;
  border: 1px solid #267ce5;
  color: #267ce5;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
}

.watchlist-modal__btn--confirm {
  background: #267ce5;
  border: 1px solid #e8e8e8;
  color: #fff;
  box-shadow: 0 0 1.5px rgba(0, 0, 0, 0.1);
}

.watchlist-modal__btn--confirm:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
